import React, { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { StatisticCont } from './Performers.styles';
import { EStatisticType } from '../../../constans/report';
import { ILeadersPerformers, ITeamsPerformers } from '../../../services/reports';
import StatisticsBox from '../../Statistics/StatisticsBox/StatisticsBox';

interface IPerformers {
  statisticType: EStatisticType;
  topData: {
    data?: ILeadersPerformers | ITeamsPerformers;
    noData: string;
  };
  bottomData: {
    data?: ILeadersPerformers | ITeamsPerformers;
    noData: string;
  };
  mostImprovedData: {
    data?: ILeadersPerformers | ITeamsPerformers;
    noData: string;
  };
}

export const Performers: FC<IPerformers> = ({
  topData,
  bottomData,
  mostImprovedData,
  statisticType,
}) => {
  const { t } = useTranslation();

  const hasMostImprovedData =
    !_.isNil(mostImprovedData.data) && !_.isEmpty(mostImprovedData.data.results);

  return (
    <StatisticCont id="StatisticCont">
      <StatisticsBox
        noDataText={topData.noData}
        name={t('report.topAndBottomPerformers.top')}
        columnName={t('report.topAndBottomPerformers.score')}
        description={topData?.data?.description || ''}
        results={topData?.data?.results || []}
        statisticType={statisticType}
      />
      <StatisticsBox
        noDataText={bottomData.noData}
        name={t('report.topAndBottomPerformers.bottom')}
        columnName={t('report.topAndBottomPerformers.score')}
        description={bottomData?.data?.description || ''}
        results={bottomData?.data?.results || []}
        statisticType={statisticType}
      />
      {hasMostImprovedData ? (
        <StatisticsBox
          noDataText={t('report.topAndBottomPerformers.noMostImproved')}
          name={t('report.topAndBottomPerformers.mostImproved')}
          columnName={t('report.topAndBottomPerformers.score')}
          description={mostImprovedData?.data?.description || ''}
          results={mostImprovedData?.data?.results || []}
          statisticType={statisticType}
        />
      ) : null}
    </StatisticCont>
  );
};

export default Performers;
